//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Controller } from "react-hook-form";
import Select, { GroupTypeBase, OptionTypeBase, SelectComponentsConfig } from 'react-select'
import CreatableSelect from 'react-select/creatable';

//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../reactSelectCommon.scss'
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';

// @ADD Component types
interface IReactSelectCommonLayoutProps {
  components?: SelectComponentsConfig<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>
  identifier?: string
  options: Array<any>
  formHooks?: any
  title?: string
  label?: string
  defaultValue?: any
  isMulti: boolean
  onChangeSelect?: any
  required?: boolean
  className?: string
  isCreatable?: boolean
  placeholder?: string
  isDisabled?: boolean
  disableClear?: boolean
  formatCreateLabel?: (inputValue: string) => React.ReactNode
}

const ReactSelectCommonLayout: React.FC<IReactSelectCommonLayoutProps> = (props) => {

  const isCreatable = (props.isCreatable) ? props.isCreatable : false
  const { t } = useTranslation()

  let defaultData: any = ''
  if (props.defaultValue) {
    if (props.isMulti && props.defaultValue.length > 0) {
      defaultData = []
      props.defaultValue.map((data: any) => {
        defaultData.push(data)
      })
    } else if (props.defaultValue && props.defaultValue[0] && props.defaultValue[0].hasOwnProperty('value')) {
      defaultData = props.defaultValue[0]
    } else {
      defaultData = ''
    }
  }

  return(
    <div className={`${props.required ? 'required' : ''} ${props.className ? props.className : ''}`}>
      {!!props?.label && (
        <LabelComponent>{props.label}</LabelComponent>
      )}
      {isCreatable ? (
        <Controller
          className='form-control-react-select'
          id={props.identifier}
          name={props.identifier ? props.identifier : ''}
          as={({ onChange, value }) => {
            return (
              <CreatableSelect
                components={props?.components}
                value={(value) ? value : ""}
                defaultValue={props.defaultValue}
                options={props.options}
                isClearable={!props.disableClear}
                onChange={(newValue: any) => {
                  if (Array.isArray(newValue) && newValue.length === 0) {
                    newValue = ""
                  }
                  onChange(newValue)
                  if (props.onChangeSelect) {
                    props.onChangeSelect(newValue)
                  }
                }}
                isMulti={props.isMulti}
                // styles={colourStyles}
                placeholder={props?.placeholder}
                formatCreateLabel={props?.formatCreateLabel}
                isDisabled={props?.isDisabled}
              />
            )
          }}
          defaultValue={defaultData}
          control={props.formHooks.control}
          rules={{ required: (props.required ? props.required : false) }}
        />
      ) : (
        <Controller
          className='form-control-react-select'
          name={props.identifier ? props.identifier : ''}
          as={({ onChange, value }) => {
            return (
              <Select
                value={(value) ? value : ""}
                // defaultValue={defaultData}
                options={props.options}
                isClearable={!props.disableClear}
                onChange={(newValue: any) => {
                  if (Array.isArray(newValue) && newValue.length === 0) {
                    newValue = ""
                  }
                  onChange(newValue)
                  if (props.onChangeSelect) {
                    props.onChangeSelect(newValue)
                  }
                }}
                isMulti={props.isMulti}
                // styles={colourStyles}
                placeholder={props?.placeholder}
                isDisabled={props?.isDisabled}
              />
            )
          }}
          defaultValue={defaultData}
          control={props?.formHooks?.control}
          rules={{ required: (props.required ? props.required : false) }}
        />
      )}

      {props.title && (
        <label className='label-select' htmlFor={props.identifier}>
          {props.title}
        </label>
      )}
    </div>
  )
}

export default ReactSelectCommonLayout
